import { DepartRetraiteUtils, Moment, Simulation } from "@mra/hlp9002";
import { PreconisationModifiee } from "../models/preconisationModifiee.model";

/**
 * Classe utilitaire pour les simulations
 */
export class SimuUtils {
    /**
     * Récupère la date d'effet du contrat
     * @param preconisationModifiee - Preconisation modifiée
     * @param simulation - Simulation MRA
     * @returns Retourne la date d'effet du contrat
     */
    public static getDateEffet(preconisationModifiee: PreconisationModifiee, simulation: Simulation): string {
        const dateEffet: Moment = new DepartRetraiteUtils().calculDateEffet(simulation.affilie.naissance.date);
        return preconisationModifiee?.dateEffet ?? simulation?.contrat?.dateEffetInitiale ?? dateEffet.format("YYYY-MM-DD");
    }
}
